<script lang="ts" setup>
const { t } = useI18n()
const router = useRouter()
const isMobile = useIsMobile()
const cartStore = useCartStore()

const buttonClasses = computed(() => {
  if (cartStore.isOpen) {
    return ['bg-white', 'cart-button--open']
  }

  return ['bg-transparent']
})

const handleCartClick = () => {
  if (cartStore.isOpen) {
    router.replace({ query: { ...router.currentRoute.value.query, openCart: undefined } })
  }

  cartStore.toggle()
}
</script>

<template>
  <RPopover v-model:show="cartStore.isOpen" :disable="isMobile">
    <template #trigger>
      <button
        class="cart-button relative flex h-10 w-10 items-center justify-center rounded-full transition-colors"
        :class="buttonClasses"
        @click.stop="handleCartClick"
      >
        <RIcon>
          <IconBag class="h-6 w-6" />
        </RIcon>

        <div
          v-if="cartStore.size > 0"
          class="counter absolute bottom-0 right-0 flex h-4 w-4 items-center justify-center rounded-full border-1 border-apple bg-apple text-xs font-semibold text-white transition-colors sm:h-[17px] sm:w-[17px] sm:text-[12px]"
        >
          {{ cartStore.size > 99 ? '99+' : cartStore.size }}
        </div>

        <span class="sr-only">{{ t('components.cartDrawer.title') }}</span>
      </button>
    </template>

    <RCart />
  </RPopover>
</template>

<style scoped>
.cart-button {
  &--open {
    color: var(--color-primary);

    .counter {
      @apply text-white;
    }
  }
}
</style>
